<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Create New Customer</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <form (submit)="handleSubmit()">

    <div class="modal-body">
      <div class="row">
        <div class="form-group col-md-6">
          <label for="firstNameInput">First Name</label>
          <input id="firstNameInput" type="text" class="form-control" name="firstName"
                 required
                 [(ngModel)]="firstName">
        </div>
        <div class="form-group col-md-6">
          <label for="lastNameInput">Last Name</label>
          <input id="lastNameInput" type="text" class="form-control" name="lastName"
                 required
                 [(ngModel)]="lastName">
        </div>
      </div>

      <div class="form-group">
        <label for="birthdayInput">Birthday</label>
        <app-date-picker [id]="'birthdayInput'"
                         [(content)]="birthday"></app-date-picker>
      </div>

      <div class="form-group">
        <label for="emailInput">Email (optional)</label>
        <input id="emailInput" type="email" class="form-control" name="email"
               autocomplete="off"
               [(ngModel)]="email">
      </div>

      <div class="form-group form-check" *ngIf="email !== ''">
        <input id="sendEmailInviteInput" type="checkbox" class="form-check-input"
               name="sendEmailInvite"
               [(ngModel)]="sendEmailInvite">
        <label class="form-check-label" for="sendEmailInviteInput">
          Send email invite
        </label>
      </div>

      <div class="alert alert-danger" role="alert" *ngIf="genericErrorMessage">
        {{ genericErrorMessage }}
      </div>

      <div class="alert alert-danger" role="alert" *ngIf="existingCustomerWithBasicInfoId">
        A customer already exists with this name and birthday.
        <br>
        <a [routerLink]="'/customers/' + existingCustomerWithBasicInfoId.toString()"
           (click)="activeModal.dismiss()"
           class="alert-link">
          Navigate to the existing customer's profile.
        </a>
      </div>

      <div class="alert alert-danger" role="alert" *ngIf="existingCustomerWithEmailId">
        This email is in use by an existing customer, {{ existingCustomerWithEmailFirstName }} {{ existingCustomerWithEmailLastName }}. Remove or change the email address in order to continue.
        <br>
        <a [routerLink]="'/customers/' + existingCustomerWithEmailId.toString()"
           (click)="activeModal.dismiss()"
           class="alert-link">
          Navigate to the existing customer's profile.
        </a>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary"
              (click)="activeModal.close()">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary"
              *ngIf="!loadingSubmit">
        Save
      </button>
      <button type="button" class="btn btn-primary disabled" disabled
              *ngIf="loadingSubmit">
        Loading...
      </button>
    </div>

  </form>

</ng-container>
